export const defaultTheme = {
    light: {
        primary: "#CF0101",
        primary50: "rgba(207, 1, 1, 0.15)",
    },
};

export const blueTheme = {
    light: {
        primary: "#3392CC",
        primary50: "rgba(51, 146, 204, 0.15)",
    },
};
export const dangerTheme = {
    light: {
        primary: "#E4042C",
        primary50: "rgba(228, 4, 44, 0.15)",
    },
};
export const brownTheme = {
    light: {
        primary: "#836529",
        primary50: "rgba(131, 101, 41, 0.15)",
    },
};
export const pinkTheme = {
    light: {
        primary: "#e404bf",
        primary50: "rgba(228, 4, 191, 0.15)",
    },
};
export const blueDarkTheme = {
    light: {
        primary: "#0E79BF",
        primary50: "rgba(14, 121, 191, 0.15)",
    },
};
export const darkPinkTheme = {
    light: {
        primary: "#DE5B9E",
        primary50: "rgba(222, 91, 158, 0.15)",
    },
};
export const dangerDarkTheme = {
    light: {
        primary: "#C6164F",
        primary50: "rgba(198, 22, 79, 0.15)",
    },
};
